import { render, staticRenderFns } from "./TasksAdd.vue?vue&type=template&id=708df297&scoped=true&"
import script from "./TasksAdd.vue?vue&type=script&lang=js&"
export * from "./TasksAdd.vue?vue&type=script&lang=js&"
import style0 from "./TasksAdd.vue?vue&type=style&index=0&id=708df297&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708df297",
  null
  
)

component.options.__file = "TasksAdd.vue"
export default component.exports